<div class="modal-container">
    <div class="modal-content">
      <h1 class="modal-title">{{ isBulkEdit ? 'Bulk Edit Device' : 'Edit Device : ' +  selectedGatewayId }}</h1>

      <!-- <p class="modal-description">
        Please select a new customer and group to assign to the selected device.
      </p> -->

      <form [formGroup]="deviceForm">
        <div class="form-row">
          <div class="form-group">
            <label for="customer">Customer<span class="required">*</span></label>
            <select id="customer" style="min-width: 100%;max-width: 100%;" formControlName="customerId" class="form-control" (change)="onCustomerChange($event)" >
              <option value="">{{ customerDropdownSelectLabel }}</option>
              @for(customer of customersList;track customer.id){
                <option [value]="customer.id">
                  {{ customer.customerName }}
                </option>
              }
            </select>
            <small *ngIf="currentCustomerInactiveNotice" class="inactive-customer-notice" role="alert">
              {{ currentCustomerInactiveNotice }}
            </small>
            <!-- <select *ngIf="this.deviceService?.deviceIds?.length >1" id="customer" formControlName="customerId" class="form-control" (change)="onCustomerChange($event)" >
              <option selected value="">Please Choose</option>
              @for(customer of customersList;track customer.id){
                <option [value]="customer.id">
                  {{ customer.customerName }}
                </option>
              }
            </select> -->
          </div>

          <div class="form-group">
            <label for="group">Group<span class="required">*</span></label>
            <select id="group" style="min-width: 100%;max-width: 100%;" formControlName="groupId" class="form-control">
                <option value="" >{{ groupDropdownEmptyLabel }}</option>
                @for(group of groups;track group.id){
                  <option  [value]="group.id">
                    {{ group.groupName }}
                  </option>
                }
            </select>
          </div>
        </div>
        <div class="form-row" *ngIf="!isBulkEdit">
          <div class="form-group">
            <label for="Asset">Asset</label>
            <input id="asset" style="min-width: 100%;max-width: 100%;" formControlName="asset" class="form-control">
          </div>
          <div class="form-group">
            <label for="installedon">Installed On (UTC)</label>
            <!-- <input type="datetime-local" id="installedon" style="min-width: 100%;max-width: 100%;" formControlName="installedOn" class="form-control" (change)="onDateChange($event)" > -->
            <mat-form-field appearance="outline">
              <input matInput [matDatepicker]="picker" formControlName="installedOn" [max]="maxDate"
                     (dateChange)="onDateChange($event.value)">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

          </div>
        </div>

        <div class="form-row" *ngIf="!isBulkEdit">
          <div class="form-group">
            <label for="status">Status</label>
            <select class="custom-dropdown" style="min-width: 100%;max-width: 100%;" class="form-control" formControlName="status">
              <option *ngFor="let s of commonService.deviceStatusOptions" [value]="s">{{ s }}</option>
          </select>
          </div>
          <div class="form-group">
            <label for="carrierProfile">Carrier Profile</label>
            <input id="carrierProfile" style="min-width: 100%;max-width: 100%;" formControlName="carrierProfile" class="form-control">
          </div>
        </div>

        <div class="button-container">
          <button mat-stroked-button mat-dialog-close style="color: #3A6570" type="button" class="btn-cancel" >
            Cancel
          </button>
          <button
            type="button"
            class="btn-confirm"
            [disabled]="!deviceForm.valid"
            (click)="onUpdate()">
            Confirm
          </button>
        </div>
      </form>
    </div>
  </div>

